import { useEffect, useState } from "react";

import ModuleChartLine from "../../../components/chart/line";
import moment from "moment";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModulePopRecordChart({ prePopOption, closePrePop }) {
  return (
    <>
      <div className="px-3 -mt-3">
        {prePopOption.data.search.startDate &&
          prePopOption.data.search.endDate && (
            <div className="text-2xl text-center font-bold text-blue-600 mb-3">{`${moment(
              prePopOption.data.search.startDate
            ).format("YYYY/MM/DD")} 至 ${moment(
              prePopOption.data.search.endDate
            ).format("YYYY/MM/DD")}`}</div>
          )}

        {prePopOption.data?.lineKey.map((lineKey, lIdx) => (
          <div
            key={lineKey.key}
            className={classNames({
              "mt-5": lIdx !== 0,
            })}
          >
            <ModuleChartItem prePopOption={prePopOption} lineKey={lineKey} />
          </div>
        ))}

        <div className="col-12 text-right">
          <Button
            type="button"
            label="關閉"
            className="p-button-secondary px-3"
            onClick={() => closePrePop({ type: prePopOption.type })}
          />
        </div>
      </div>
    </>
  );
}

function ModuleChartItem({ prePopOption, lineKey }) {
  const [chartData, setChartData] = useState({
    data: [],
    options: {
      margin: {
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      },
    },
  });

  useEffect(() => {
    let temp = { ...chartData };
    temp.data = prePopOption.data.data;
    setChartData(temp);
  }, [prePopOption.data]);

  return (
    <>
      <div className="text-center text-2xl text-blue-600 font-bold mb-2">
        {lineKey.label}變化趨勢圖
      </div>
      <div className="h-20rem">
        <ModuleChartLine
          cData={chartData.data}
          cOptions={chartData.options}
          lineKey={[lineKey]}
          referenceKey={prePopOption.data.referenceKey?.[lineKey.key] ?? []}
        />
      </div>
    </>
  );
}
